import { Box, Typography } from '@mui/material'

import { TwoFactorEnforcementState } from '@/api/types'
import { formatDate } from '@/utils/datetime'

interface Props {
  // Masked address from the login token or the details payload; absent when neither carries one.
  email?: string | null
  enforcementDate?: string | null
  enforcementState?: TwoFactorEnforcementState
}

// While enforcement is off, email is just the user's method; otherwise it lasts until the enforcement date.
export function EmailMethodNotice({ email, enforcementDate, enforcementState }: Props) {
  const isOff = enforcementState === TwoFactorEnforcementState.Off

  return (
    <Box>
      <Typography variant="body2">
        Your current method is email{email ? ` to ${email}` : ''}.{isOff ? '' : ' You can keep using it for now.'}
      </Typography>
      {!!enforcementDate && !isOff && (
        <Typography variant="body2">
          Email codes stop working on {formatDate(enforcementDate, 'MMMM D, YYYY')}.
        </Typography>
      )}
    </Box>
  )
}
